import { recordPath, recordRoute } from '@/shared/registry'

/** Where the certificate template pages live. */
export const certificateTemplatesPath = '/credentials/certificate-templates'
export const createCertificateTemplatePath = `${certificateTemplatesPath}/new`
export const certificateTemplateRoute = recordRoute('credentials', 'certificate-templates')
export const editCertificateTemplateRoute = `${certificateTemplateRoute}/edit`

/** A certificate template's details page. */
export function certificateTemplatePath(id: string): string {
  return recordPath('credentials', 'certificate-templates', id)
}

/** The base of Certificate Template Details' slots (`detailsSlots`). */
export const certificateTemplateDetailsSlot = 'credentials.certificate-template-details'

/** The permissions the certificate template screens show or hide their actions by. */
export const readCertificateTemplatesPermission = 'credentials.certificate-templates.read'
export const writeCertificateTemplatesPermission = 'credentials.certificate-templates.write'
export const deleteCertificateTemplatesPermission = 'credentials.certificate-templates.delete'

/** The API's certificate template endpoints. */
export const certificateTemplatesApi = '/credentials/v1/certificate-templates'

export function certificateTemplateApi(id: string): string {
  return `${certificateTemplatesApi}/${encodeURIComponent(id)}`
}
